import { T } from '@tolgee/react';
import { useEffect, useState } from 'react';
import styled from 'styled-components';

import CuriRocketBigFlameSvg from '../../../assets/icons/CuriRocketBigFlameSvg';
import CuriRocketSvg from '../../../assets/icons/CuriRocketSvg';
import { useBreakPoint } from '../../../hooks/useBreakPoint';
import { shuffleArray } from '../../../utils/arrayUtils';
import { LoadingDots } from '../../_atoms/DismissableQuestionList/DismissableQuestionList';

export const tips = [
  <T
    key="Understand the different learning styles and needs of your students and adapt your teaching methods accordingly."
    keyName="Understand the different learning styles and needs of your students and adapt your teaching methods accordingly."
    defaultValue="Understand the different learning styles and needs of your students and adapt your teaching methods accordingly."
  />,
  <T
    key="An open question followed by a group discussion is a great way of exploring a topic in depth."
    keyName="An open question followed by a group discussion is a great way of exploring a topic in depth."
    defaultValue="An open question followed by a group discussion is a great way of exploring a topic in depth."
  />,
  <T
    key="Introducing a new topic? Start with a wordcloud and find out what your students already know."
    keyName="Introducing a new topic? Start with a wordcloud and find out what your students already know."
    defaultValue="Introducing a new topic? Start with a wordcloud and find out what your students already know."
  />,
  <T
    key="With Curipod you can use the AI generated lesson live in the classroom to spark engagement and creativity."
    keyName="With Curipod you can use the AI generated lesson live in the classroom to spark engagement and creativity."
    defaultValue="With Curipod you can use the AI generated lesson live in the classroom to spark engagement and creativity."
  />,
  <T
    key="Use the moderator tool during Live to filter out inappropriate responses."
    keyName="Use the moderator tool during Live to filter out inappropriate responses."
    defaultValue="Use the moderator tool during Live to filter out inappropriate responses."
  />,
  <T
    key="Create a positive and inclusive classroom environment where all students feel comfortable and respected."
    keyName="Create a positive and inclusive classroom environment where all students feel comfortable and respected."
    defaultValue="Create a positive and inclusive classroom environment where all students feel comfortable and respected."
  />,
  <T
    key="Use a variety of teaching methods, such as lectures, discussions, and hands-on activities, to keep students engaged and interested."
    keyName="Use a variety of teaching methods, such as lectures, discussions, and hands-on activities, to keep students engaged and interested."
    defaultValue="Use a variety of teaching methods, such as lectures, discussions, and hands-on activities, to keep students engaged and interested."
  />,
  <T
    key="Use a variety of Curipod activities, such as drawings, polls and open ended questions to keep students engaged and interested."
    keyName="Use a variety of Curipod activities, such as drawings, polls and open ended questions to keep students engaged and interested."
    defaultValue="Use a variety of Curipod activities, such as drawings, polls and open ended questions to keep students engaged and interested."
  />,
  <T
    key="Provide regular and timely feedback on student progress to help them see their strengths and areas for improvement."
    keyName="Provide regular and timely feedback on student progress to help them see their strengths and areas for improvement."
    defaultValue="Provide regular and timely feedback on student progress to help them see their strengths and areas for improvement."
  />,
  <T
    key="Encourage student participation and make sure every student has an opportunity to speak and share their ideas."
    keyName="Encourage student participation and make sure every student has an opportunity to speak and share their ideas."
    defaultValue="Encourage student participation and make sure every student has an opportunity to speak and share their ideas."
  />,
  <T
    key="Always fact check the content generated by the AI."
    keyName="Always fact check the content generated by the AI."
    defaultValue="Always fact check the content generated by the AI."
  />,
  <T
    key="Plan and execute lessons that are aligned with the curriculum and aligned with the standards and goals of the school/district."
    keyName="Plan and execute lessons that are aligned with the curriculum and aligned with the standards and goals of the school/district."
    defaultValue="Plan and execute lessons that are aligned with the curriculum and aligned with the standards and goals of the school/district."
  />,
  <T
    key="Build positive relationships with your students by getting to know them as individuals and showing genuine interest in their lives and experiences."
    keyName="Build positive relationships with your students by getting to know them as individuals and showing genuine interest in their lives and experiences."
    defaultValue="Build positive relationships with your students by getting to know them as individuals and showing genuine interest in their lives and experiences."
  />,
  <T
    key="Continuously reflect on your teaching practice. Look for ways to improve and grow as an educator. #growthmindset"
    keyName="Continuously reflect on your teaching practice. Look for ways to improve and grow as an educator. #growthmindset"
    defaultValue="Continuously reflect on your teaching practice. Look for ways to improve and grow as an educator. #growthmindset"
  />,
  <T
    key="Be flexible and adaptable to meet the changing needs of your students, especially during unexpected events like a pandemic or inclement weather."
    keyName="Be flexible and adaptable to meet the changing needs of your students, especially during unexpected events like a pandemic or inclement weather."
    defaultValue="Be flexible and adaptable to meet the changing needs of your students, especially during unexpected events like a pandemic or inclement weather."
  />,
  <T
    key="Establish clear objectives for your lessons and make sure students understand what they are expected to learn."
    keyName="Establish clear objectives for your lessons and make sure students understand what they are expected to learn."
    defaultValue="Establish clear objectives for your lessons and make sure students understand what they are expected to learn."
  />,
  <T
    key="Differentiate instruction to meet the needs of diverse learners, such as providing additional support or enrichment activities."
    keyName="Differentiate instruction to meet the needs of diverse learners, such as providing additional support or enrichment activities."
    defaultValue="Differentiate instruction to meet the needs of diverse learners, such as providing additional support or enrichment activities."
  />,
  <T
    key="Use real-life examples and connections to make the material relevant and meaningful to students."
    keyName="Use real-life examples and connections to make the material relevant and meaningful to students."
    defaultValue="Use real-life examples and connections to make the material relevant and meaningful to students."
  />,
  <T
    key="Encourage critical thinking, problem-solving, and creativity in your instruction."
    keyName="Encourage critical thinking, problem-solving, and creativity in your instruction."
    defaultValue="Encourage critical thinking, problem-solving, and creativity in your instruction."
  />,
  <T
    key="An AI lesson should always be considered a draft that needs the human touch from the teacher."
    keyName="An AI lesson should always be considered a draft that needs the human touch from the teacher."
    defaultValue="An AI lesson should always be considered a draft that needs the human touch from the teacher."
  />,
  <T
    key="Incorporate group work and collaborative learning activities to promote socialization and teamwork."
    keyName="Incorporate group work and collaborative learning activities to promote socialization and teamwork."
    defaultValue="Incorporate group work and collaborative learning activities to promote socialization and teamwork."
  />,
  <T
    key="Allow students to take ownership of their learning by giving them choice and autonomy."
    keyName="Allow students to take ownership of their learning by giving them choice and autonomy."
    defaultValue="Allow students to take ownership of their learning by giving them choice and autonomy."
  />,
  <T
    key="Provide opportunities for students to apply what they have learned through projects, performance tasks, and real-world scenarios."
    keyName="Provide opportunities for students to apply what they have learned through projects, performance tasks, and real-world scenarios."
    defaultValue="Provide opportunities for students to apply what they have learned through projects, performance tasks, and real-world scenarios."
  />,
  <T
    key="Use formative assessment strategies regularly to check for understanding and adjust instruction accordingly."
    keyName="Use formative assessment strategies regularly to check for understanding and adjust instruction accordingly."
    defaultValue="Use formative assessment strategies regularly to check for understanding and adjust instruction accordingly."
  />,
  <T
    key="Foster a growth mindset in your students by emphasizing effort, progress, and perseverance rather than just grades or test scores."
    keyName="Foster a growth mindset in your students by emphasizing effort, progress, and perseverance rather than just grades or test scores."
    defaultValue="Foster a growth mindset in your students by emphasizing effort, progress, and perseverance rather than just grades or test scores."
  />,
  <T
    key="Use positive reinforcement and recognize students for their efforts and successes."
    keyName="Use positive reinforcement and recognize students for their efforts and successes."
    defaultValue="Use positive reinforcement and recognize students for their efforts and successes."
  />,
  <T
    key="Provide ongoing professional development and stay up to date with the latest teaching strategies and research in your field."
    keyName="Provide ongoing professional development and stay up to date with the latest teaching strategies and research in your field."
    defaultValue="Provide ongoing professional development and stay up to date with the latest teaching strategies and research in your field."
  />,
  <T
    key="Use inclusive language and avoid stereotypes to create a safe and welcoming environment for all students, regardless of their background or identity."
    keyName="Use inclusive language and avoid stereotypes to create a safe and welcoming environment for all students, regardless of their background or identity."
    defaultValue="Use inclusive language and avoid stereotypes to create a safe and welcoming environment for all students, regardless of their background or identity."
  />,
  <T
    key="Use a variety of assessment methods, such as written tests, projects, presentations, and portfolios, to provide a more comprehensive understanding of student learning."
    keyName="Use a variety of assessment methods, such as written tests, projects, presentations, and portfolios, to provide a more comprehensive understanding of student learning."
    defaultValue="Use a variety of assessment methods, such as written tests, projects, presentations, and portfolios, to provide a more comprehensive understanding of student learning."
  />,
  <T
    key="Provide opportunities for students to give feedback on their learning experience and incorporate their suggestions into your teaching practice."
    keyName="Provide opportunities for students to give feedback on their learning experience and incorporate their suggestions into your teaching practice."
    defaultValue="Provide opportunities for students to give feedback on their learning experience and incorporate their suggestions into your teaching practice."
  />,
  <T
    key="Encourage students to ask questions and be curious, and provide resources for them to explore topics that interest them."
    keyName="Encourage students to ask questions and be curious, and provide resources for them to explore topics that interest them."
    defaultValue="Encourage students to ask questions and be curious, and provide resources for them to explore topics that interest them."
  />,
  <T
    key="Emphasize the importance of academic integrity and teach students how to cite sources and avoid plagiarism."
    keyName="Emphasize the importance of academic integrity and teach students how to cite sources and avoid plagiarism."
    defaultValue="Emphasize the importance of academic integrity and teach students how to cite sources and avoid plagiarism."
  />,
  <T
    key="Use humor and storytelling to make lessons more engaging and memorable for students."
    keyName="Use humor and storytelling to make lessons more engaging and memorable for students."
    defaultValue="Use humor and storytelling to make lessons more engaging and memorable for students."
  />,
  <T
    key="Create a classroom culture of respect and kindness by modeling positive behavior and addressing any instances of bullying or negative interactions among students."
    keyName="Create a classroom culture of respect and kindness by modeling positive behavior and addressing any instances of bullying or negative interactions among students."
    defaultValue="Create a classroom culture of respect and kindness by modeling positive behavior and addressing any instances of bullying or negative interactions among students."
  />,
  <T
    key="Collaborate with other teachers and education professionals to share ideas and learn from one another, and to develop a strong sense of community within your school."
    keyName="Collaborate with other teachers and education professionals to share ideas and learn from one another, and to develop a strong sense of community within your school."
    defaultValue="Collaborate with other teachers and education professionals to share ideas and learn from one another, and to develop a strong sense of community within your school."
  />,
  <T
    key="Use as is, or edit and make it yours!"
    keyName="Use as is, or edit and make it yours!"
    defaultValue="Use as is, or edit and make it yours!"
  />,
  <T
    key="Remember to fact check - AI can make mistakes"
    keyName="Remember to fact check - AI can make mistakes"
    defaultValue="Remember to fact check - AI can make mistakes"
  />,
  <T
    key="Click Start lesson to see classroom view"
    keyName="Click Start lesson to see classroom view"
    defaultValue="Click Start lesson to see classroom view"
  />,
];

export const AnimatedTipsV2 = ({
  isSmallTemplates,
  darkMode = false,
}: {
  isSmallTemplates?: boolean;
  darkMode?: boolean;
}) => {
  const [selectedTipIndex, setSelectedTipIndex] = useState(0);
  const [randomisedTips, setRandomisedTips] = useState<React.ReactNode[] | null>();
  const isLargerThan600 = useBreakPoint(600);
  useEffect(() => {
    setRandomisedTips(shuffleArray(tips));
  }, []);

  useEffect(() => {
    if (randomisedTips) {
      if (selectedTipIndex < randomisedTips.length) {
        const timer = setInterval(() => setSelectedTipIndex(selectedTipIndex + 1), 10000);
        return () => clearInterval(timer);
      } else {
        setSelectedTipIndex(0);
      }
    }
  }, [selectedTipIndex, randomisedTips]);

  return (
    <AnimatedTipsContainer>
      {isLargerThan600 && (
        <h1
          style={{
            fontSize: 20,
            marginBottom: 20,
            textAlign: 'center',
            color: 'white',
          }}
        >
          <T keyName="A wise teacher once said" defaultValue="A wise teacher once said" />
          :
        </h1>
      )}
      {randomisedTips &&
        randomisedTips.map((tip, i) => (
          <>
            {i === selectedTipIndex && (
              <StyledTip
                $isVisible={i === selectedTipIndex}
                key={i}
                $isSmallTemplates={isSmallTemplates}
                style={{ color: 'white' }}
              >
                &ldquo;{tip}&rdquo;
              </StyledTip>
            )}
          </>
        ))}
    </AnimatedTipsContainer>
  );
};

const ProgressBarV2 = ({
  title,
  isSmallTemplates,
  darkMode = false,
}: {
  title?: string;
  isSmallTemplates?: boolean;
  darkMode?: boolean;
}) => {
  return (
    <>
      <h1
        style={{
          color: 'white',
        }}
      >
        {title ?? <T keyName="Customizing lesson" defaultValue="Customizing lesson" />}
        <LoadingDots>...</LoadingDots>
      </h1>
      <LoadingContainer>
        <ProgressLine>
          <CuriRocketSvg />
          <CuriRocketBigFlameSvg />
        </ProgressLine>
      </LoadingContainer>
      <AnimatedTipsV2 darkMode={darkMode} isSmallTemplates={isSmallTemplates} />
    </>
  );
};

export default ProgressBarV2;

const LoadingContainer = styled.div`
  width: 80%;
  padding: 10px;
  margin-top: 50px;

  @media (max-width: 800px) {
    margin-top: 50px;
    width: 70%;
  }
  @media (max-width: 450px) {
    margin-top: 30px;
    width: 75%;
  }
`;

const ProgressLine = styled.div`
  position: relative;
  width: 0%;
  height: 40px;
  transform: rotate(0deg);
  transform-origin: center;
  animation: progress 10s infinite ease-in-out,
    moveRocketUpAndDown 8s infinite ease-in-out;
  svg {
    height: 150px;
    width: 150px;
    position: absolute;
    right: -75px;
    top: -50px;
    transform: rotate(0deg);
    transform-origin: center;
    animation: rotateRocket 10s infinite ease-in-out;
  }

  svg:last-child {
    animation: flames 0.2s infinite linear, rotateRocket 10s infinite ease-in-out;
  }

  @media (max-width: 450px) {
    svg {
      height: 100px;
      width: 100px;
      right: -50px;
      top: -25px;
    }
  }

  @keyframes progress {
    0% {
      width: 10%;
    }

    50% {
      width: 90%;
    }

    100% {
      width: 10%;
    }
  }

  @keyframes rotateRocket {
    0% {
      transform: rotate(15deg);
    }
    50% {
      transform: rotate(-90deg);
    }

    100% {
      transform: rotate(15deg);
    }
  }

  @keyframes flames {
    0% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }

  @keyframes moveRocketUpAndDown {
    0% {
      transform: translateY(-0px);
    }
    25% {
      transform: translateY(75px);
    }
    50% {
      transform: translateY(25px);
    }
    75% {
      transform: translateY(75px);
    }

    100% {
      transform: translateY(-0px);
    }
  }
`;

const AnimatedTipsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 150px;

  width: 90%;
  margin-bottom: 150px;

  @media (max-width: 450px) {
    width: 90%;
    margin-top: 120px;
  }
`;

const StyledTip = styled.p<{ $isVisible: boolean; $isSmallTemplates?: boolean }>`
  opacity: 0;
  width: 100%;
  font-style: italic;
  min-height: 200px;
  font-size: ${({ $isSmallTemplates }) => ($isSmallTemplates ? '18px' : '22px')};
  text-align: center;
  animation: ${({ $isVisible }) => ($isVisible ? 'fadeIn 10s linear' : '')};

  p {
    margin: 0 auto;
  }

  @media (max-width: 600px) or (max-height: 600px) {
    font-size: 16px;

    h1 {
      font-size: 18px !important;
    }
  }

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    6% {
      opacity: 1;
    }
    94% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
`;
